import defaultTheme from './default';
import type { IMenuTheme } from './types/IMenuTheme';

export const MenuTheme: IMenuTheme = defaultTheme;
